export { default } from './LazyPAYGPolicy';
